import { fromJS, Map } from 'immutable';
import actionTypes from 'constants/countriesConstants';

export const initialState = fromJS({
  list: [],
  isLoading: false,
});

function list(state, action) {
  switch (action.type) {
    case actionTypes.FETCH_COUNTRIES_SUCCESS:
      return fromJS(action.payload);
    default:
      return state;
  }
}

function isLoading(state, action) {
  switch (action.type) {
    case actionTypes.FETCH_COUNTRIES_REQUEST:
      return true;
    case actionTypes.FETCH_COUNTRIES_SUCCESS:
    case actionTypes.FETCH_COUNTRIES_FAILURE:
      return false;
    default:
      return state;
  }
}

const countriesReducer = (state = initialState, action) => {
  return Map({
    list: list(state.get('list'), action),
    isLoading: isLoading(state.get('isLoading'), action),
  });
};

export default countriesReducer;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/countriesReducer.js